import { render, staticRenderFns } from "./TaskRow.vue?vue&type=template&id=cd8ac5ae&scoped=true&lang=pug&"
import script from "./TaskRow.vue?vue&type=script&lang=js&"
export * from "./TaskRow.vue?vue&type=script&lang=js&"
import style0 from "./TaskRow.vue?vue&type=style&index=0&id=cd8ac5ae&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8ac5ae",
  null
  
)

export default component.exports